module.exports = __webpack_public_path__ + "img/Cleric.036a19da.png";